import LTR from "@brand-icons/global/play/play-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PlayIcon = iconFactory("PlayIcon", LTR);
